export const StoreQueryParamName = "st";
